"use client";

import { Loader2 } from "lucide-react";
import React from "react";
import { ShowWithComedian } from "@punchup/data/legacy";
import WaitlistModalBase from "./WaitlistModalBase";

interface LeaveWaitlistModalProps {
  show: ShowWithComedian;
  onClose: () => void;
  onConfirm: () => void;
  isLeaving?: boolean;
}

const LeaveIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#EF4444" />
    <path
      d="M12 14 L24 14 M12 18 L24 18 M12 22 L24 22"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const LeaveWaitlistModal: React.FC<LeaveWaitlistModalProps> = ({
  show,
  onClose,
  onConfirm,
  isLeaving = false,
}) => {
  return (
    <WaitlistModalBase show={show} onClose={onClose} badgeIcon={<LeaveIcon />}>
      <div className="text-center mb-6">
        <p className="text-xl font-semibold mb-2">
          Are you sure you want to leave the waitlist?
        </p>
        <p className="text-gray-500 text-sm">
          You will no longer receive notifications about new dates or when
          tickets become available for this show.
        </p>
      </div>

      <div className="space-y-4">
        <button
          onClick={onConfirm}
          disabled={isLeaving}
          className="w-full py-3 px-4 rounded-lg font-medium transition-colors bg-red-500 hover:bg-red-600 text-white disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLeaving ? (
            <Loader2 className="animate-spin mx-auto" size={20} />
          ) : (
            "Yes, leave the waitlist"
          )}
        </button>
        <button
          onClick={onClose}
          disabled={isLeaving}
          className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 px-4 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
      </div>
    </WaitlistModalBase>
  );
};

export default LeaveWaitlistModal;
